import http from "./httpService";

const apiEndpoint ="/audioplayer/api/player/ims/playlists/info";


export function getAll() {
    return http.get(apiEndpoint);
}

export function getAllFiles() {
    return http.get("/audioplayer/api/player/ims/files");
}


const ImsPlaylistsService = {getAll, getAllFiles};

export default ImsPlaylistsService;

